/*
 * @Author: Dom
 * @Date: 2022-05-30 15:49:05
 * @LastEditTime: 2022-06-30 20:07:41
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\views\account\recharge\store.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';

import { searchType } from './data'
import { getOrderEvents } from './service'

export interface StateType {
    errorMsg?: string;
    orderEvents:any;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getOrderEventsData: Mutation<StateType>;
    };
    actions: {
        getOrderEventsFn: Action<StateType, StateType>;
    };
}

const initState: StateType = {
    errorMsg: undefined,
    orderEvents: {}
}

const StoreModel:ModuleType = {
    namespaced: true,
    name: 'logisticstrack',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        getOrderEventsData(state, payload){
            state.orderEvents = payload
        },
    },
    actions: {
        async getOrderEventsFn({commit}, params:searchType){
            let msg: string | undefined = undefined
            try{
                const req: ResponseData = await getOrderEvents(params)
                const { body } = req
                const countrylistSet = JSON.parse(String(localStorage.getItem('person')))
                countrylistSet.map((item: any) => {
                    body.map((tag:any) => {
                        if (item.code == tag.destination) {
                            tag.destination = item.name + '('+ item.code +')'
                        }
                        tag.orderEvents = tag.orderEvents&&tag.orderEvents.filter((i:any) => {
                            if(i.display){
                                return i
                            }
                        })
                    })
                })
                commit('getOrderEventsData',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
